import styled from "styled-components";

export const GrainComponent = styled.div`
    max-width: 1200px;
    margin: 30px auto;
`

export const Container = styled.div`
    position: relative;
    background: ${({ background }) => background ? `url(${background}) center center no-repeat` : 'none'};
    background-size: cover;
    border-radius: 5px;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    min-height: 300px;
    overflow: hidden;
    transition: opacity 0.2s ease-in-out;
    margin: 5px;
`;


export const BackgroundOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: ${({ background }) =>
    background ? `url(${background}) center center no-repeat` : 'none'};
  background-size: cover;
  opacity: 0;
  animation: fadeIn 0.4s ease-in-out forwards;
  z-index: 0;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const GrainCommercialTitle = styled.div`
    margin: 10px;
    h2 {
      font-size: 2.3rem;
      font-weight: 500;
      color: var(--first-color);
      word-wrap: break-word;
      margin-bottom: 10px;
    }

    p {
        margin-bottom: 2rem;
        font-size: 20px;
        color: var(--black-color);
        font-weight: 600;
        text-align: justify;
    }
`

export const Grid = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between; 
    
    

    & > * {
        flex: 1 1 180px; 
        max-width: calc(100% - 16px);
    }

    @media screen and (max-width: 700px) {
        flex-direction: column;
    }
`;

export const GridItem = styled.div`
  border: 0.5px solid rgba(255, 255, 255, 0.7);
  height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  font-size: 1.25rem;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  padding: 20px;
  position: relative;
  transition: all 0.5s ease-in-out;

  .faixa {
    width: 100%;
    height: 1px;
    background: var(--tenth-color);
    margin-bottom: 10px;
    opacity: 0;
    transition: all 0.5s ease-in-out;
  }

  .subtitle {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: all 0.5s ease-in-out;
    font-size: 1rem;
    margin-top: 10px;
  }

  &:hover .faixa {
    opacity: 1;
  }

  &:hover .subtitle {
    max-height: 300px;
    opacity: 1;
  }

  @media screen and (max-width: 700px) {
    background-image: linear-gradient(
        rgba(0, 0, 0, 0.5),
        rgba(0, 0, 0, 0.5)
      ),
      ${({ background }) => (background ? `url(${background})` : 'none')};
    background-size: cover;
    background-position: center;
  }
`;



export const TabsGrain = styled.div`
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: start;
    height: 30px;
`

export const TabsSingle = styled.div`
    width: 50px;
    height: 5px;
    border-radius: 6px;
    cursor: pointer;
`